import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue";
import BaseInput from "../shared/inputs/base/BaseInput.vue";
import DOMPurify from "dompurify";


const __default__ = {
  name: "CompanyInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
  },
  parentValue: {
    type: String,
    default: "",
  },
},
  emits: ["update:value"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const inputValue = computed({
  get(): string {
    return props.value as string;
  },
  set(inputValue: string) {
    const sanitizedValue = DOMPurify.sanitize(inputValue);
    emit("update:value", sanitizedValue);
  },
});

watch(
  () => props.parentValue,
  (newParentValue) => {
    if (newParentValue) {
      emit("update:value", "");
    }
  }
);

const __returned__ = { props, emit, inputValue, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})